import React, { useEffect, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { Router } from './router/router'
import GlobalStyles from './styles/GlobalStyle'
import { Theme } from './styles/GlobalTheme'
import api from './services/api'

function App() {
  const tempoLimiteInatividade = 10 * 60 * 1000

  const [lastTimeInterected, setLastTimeInterected] = useState(
    new Date().getTime(),
  )

  const clearLocalStorage = () => {
    localStorage.clear()
    window.location.reload()
  }

  // const verificarInatividade = () => {
  //   const timeNow = new Date().getTime()
  //   const timeInactive = timeNow - lastTimeInterected

  //   if (timeInactive > tempoLimiteInatividade) {
  //     clearLocalStorage()
  //   }

  //   setLastTimeInterected(timeNow)
  // }

  // useEffect(() => {
  //   const handleInteracao = () => {
  //     verificarInatividade()
  //   }

  //   document.addEventListener('click', handleInteracao)

  //   return () => {
  //     document.removeEventListener('click', handleInteracao)
  //   }
  // }, [])

  return (
    <>
      <BrowserRouter>
        <ThemeProvider theme={Theme}>
          <GlobalStyles />
          <Router />
        </ThemeProvider>
      </BrowserRouter>
    </>
  )
}

export default App
